import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgBitcoin = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "none", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M10.737 14.588c.895.236 2.853.754 3.164-.497.318-1.278-1.58-1.704-2.505-1.912l-.27-.062-.602 2.415zm.845-3.53c.747.2 2.375.634 2.658-.502.29-1.162-1.293-1.512-2.066-1.683l-.226-.052-.546 2.19z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.58 21.7c5.357 1.336 10.783-1.924 12.119-7.28 1.335-5.358-1.925-10.785-7.282-12.12C9.06.963 3.634 4.223 2.299 9.581.963 14.94 4.224 20.365 9.58 21.701m4.629-13.647c1.385.477 2.398 1.192 2.2 2.523-.145.974-.685 1.445-1.402 1.611.984.513 1.485 1.299 1.008 2.661-.592 1.692-1.999 1.835-3.87 1.481l-.454 1.82-1.097-.274.448-1.795a41 41 0 0 1-.874-.227l-.45 1.804-1.096-.274.454-1.823-.304-.079-.478-.123-1.428-.356.545-1.256s.808.215.797.2c.31.076.449-.127.503-.262l.718-2.876.115.029a1 1 0 0 0-.114-.037l.512-2.053c.014-.233-.067-.528-.511-.638.017-.012-.797-.199-.797-.199l.292-1.171 1.513.377-.001.006q.342.084.7.165l.45-1.802 1.097.273-.44 1.767c.293.067.59.135.878.207l.437-1.755 1.098.273z",
      clipRule: "evenodd"
    }
  )
] }));

export { SvgBitcoin as default };
//# sourceMappingURL=bitcoin.mjs.map
